export const RFID_FILE_DOWNLOAD_REQUEST = 'RFID_FILE_DOWNLOAD_REQUEST';
export const RFID_FILE_DOWNLOAD_SUCCESS = 'RFID_FILE_DOWNLOAD_SUCCESS';
export const RFID_FILE_DOWNLOAD_FAILURE = 'RFID_FILE_DOWNLOAD_FAILURE';
